import React, { useState } from "react";
import { Text, View } from "react-native";
import { fetchApi } from "../api";
import { STYLES } from "../assets/styles";
import Logo from "../common/Logo";
import CustomButton from "./CustomButton";
import CustomInput from "./CustomInput";

function SignUP({
  onVerifyUser = () => {},
  onLoadingChange = () => {},
  onSignInPress = () => {},
  containerStyle = {},
  color = STYLES.colors.white,
  transparent,
}) {
  const [username, setUsername] = useState("");
  const [required, setRequired] = useState(false);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSignUp = () => {
    if (username && password && email) {
      onLoadingChange(true);
      let bodyObj = {
        username: username,
        password: password,
        user: email,
      };
      fetchApi({
        path: "/register/",
        method: "POST",
        body: bodyObj,
      }).then((res) => {
        if (res.error) {
          setError(res.error_description);
        } else {
          onVerifyUser(res);
        }
        onLoadingChange(false);
      });
    } else {
      setRequired(true);
    }
  };

  return (
    <View
      style={[
        transparent ? {} : STYLES.shadow,
        {
          width: "90%",
          padding: 20,
        },
        containerStyle,
      ]}
    >
      <Logo color={color} />
      <Text
        style={{
          color: color,
          fontSize: STYLES.fontSizes.xlarge,
          marginVertical: 15,
        }}
      >
        {"Create Account"}
      </Text>
      <CustomInput
        leftIcon={{
          type: "FontAwesome",
          name: "user",
        }}
        iconStyle={{ color: color }}
        transparent={transparent}
        value={username}
        onChangeText={(value) => {
          setUsername(value);
          setError("");
          setRequired(false);
        }}
        color={color}
        required={true}
        error={required && !username}
        requiredText="Your username to identify"
        style={{ marginVertical: 10 }}
        placeholder="Username"
      />
      <CustomInput
        leftIcon={{
          type: "MaterialCommunityIcons",
          name: "email-newsletter",
        }}
        iconStyle={{ color: color }}
        color={color}
        required
        requiredText="Your email id eg: example@gmail.com"
        error={required && !email}
        value={email}
        onChangeText={(value) => {
          setEmail(value);
          setRequired(false);
          setError(null);
        }}
        transparent={transparent}
        placeholder="Enter Email"
      />
      <CustomInput
        leftIcon={{ type: "MaterialIcons", name: "lock" }}
        rightIcon={{
          type: "Ionicons",
          name: showPassword ? "md-eye" : "md-eye-off",
          onPress: () => setShowPassword(!showPassword),
        }}
        iconStyle={{ color: color }}
        transparent={transparent}
        secureTextEntry={!showPassword}
        value={password}
        onChangeText={(value) => {
          setPassword(value);
          setRequired(false);
          setError("");
        }}
        color={color}
        requiredText="Your password for security"
        required={true}
        error={required && !password}
        style={{ marginVertical: 10 }}
        placeholder="Password"
      />
      {error ? (
        <Text style={{ color: STYLES.colors.tomato, textAlign: "center" }}>
          {error}
        </Text>
      ) : null}
      <CustomButton
        text="Sign Up"
        btnStyle={{
          marginVertical: 10,
          backgroundColor: transparent ? "#ffffff" : "#000000",
        }}
        iconStyle={{ color: "#ffffff" }}
        leftIcon={{
          type: "MaterialCommunityIcons",
          name: "email-newsletter",
        }}
        onPress={handleSignUp}
        textStyle={{ color: transparent ? "#000000" : "#ffffff" }}
      />
      <CustomButton
        onPress={onSignInPress}
        text="Already have an account? sign in"
        transparent
        btnStyle={{
          marginVertical: 10,
        }}
        textStyle={{
          color: color,
          fontSize: STYLES.fontSizes.small,
        }}
      />
    </View>
  );
}

export default SignUP;
